import { createFileRoute } from '@tanstack/react-router'
import { ResellerEditPage } from '@/features/resellers-admin/pages/reseller-edit'
import { requireRole } from '@/lib/auth-guards'

export const Route = createFileRoute('/_authenticated/resellers/$id')({
  beforeLoad: requireRole(['admin']),
  component: RouteComponent,
})

function RouteComponent() {
  const { id } = Route.useParams()
  return <ResellerEditPage resellerId={id} />
}
